import './shimmer-text.scss';

import ShimmerText from './ShimmerText';

export default ShimmerText;
